import MergedTableHeader from "../../../component/common/dataGrid/MergedTableHeader";

import '../../../css/popup.css';

export default function upload_form({ atchDta, handleFileChange, setChecked, checked, output, sendData, excelData, replace, head, data, handelOptions, save, exit, title, changed, flag }) {
    return (
        <div className='upload_form bg_tr_bg'>
            <div className='flex flex-col gap-2 text-center'>
                <h4>{flag ? sendData.localStorageName === 'befSchdul' ? '사전 근무표 등록' : '사후 근무표 등록' : '인력정보 등록'}</h4>
                <span className='notice_file'>{flag ? sendData.localStorageName === 'befSchdul' ? '사전 근무표 업로드 화면입니다.' : '사후 근무표 업로드 화면입니다.' : title + ' 인력정보 업로드 화면입니다.'}<strong className='ml-1 co_red'>반드시 새로운 양식을 다운받아 업로드</strong>해주시기 바랍니다.</span>
            </div>
            <hr/>
            <div className='flex flex-col gap-8'>
                <div className='flex flex-col gap-2'>
                    <h5 className='tr_primary'>1. 파일 업로드</h5>
                    <div className='flex flex-col'>
                        <hr className={`border-t-2 tr_border_primary`} />
                        <table className='file_upload'>
                            <colgroup>
                                <col width='20%' />
                                <col width='80%' />
                            </colgroup>
                            <tbody>
                                <tr className='file'>
                                    <th>
                                        <div>
                                            {flag ? sendData.localStorageName === 'befSchdul' ? '사전 근무표 파일' : '사후 근무표 파일' : '자원정보파일'}
                                        </div>
                                    </th>
                                    <td colSpan={3}>
                                        <input type="file" id="atchDta" name="atchDta" onChange={handleFileChange} className="w-full" />
                                    </td>
                                </tr>
                                <tr className='file'>
                                    <th>
                                        <div>
                                            시트선택
                                        </div>
                                    </th>
                                    <td>
                                    {atchDta.length !== 0 ?
                                        <>
                                            <input type="radio" value={output} checked={checked === output} onChange={(e) => setChecked(e.target.value)} />{output}
                                        </>
                                    :
                                        <></>}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                {flag ? '' :
                <div className='flex flex-col gap-2'>
                    <h5 className='tr_primary'>2. 파일 업로드 정보</h5>
                    <div class='data_grid_container'>
                        <hr className={`border-t-2 mr-1-1 tr_border_primary`} />
                        <div className={`data_list_table`} style={{ maxHeight: '8.1rem' }}>
                            <table>
                                <MergedTableHeader
                                    headers={sendData.head}
                                />
                                <tbody>
                                    {excelData[checked] ?
                                        replace?.map((item, rowIndex) => {
                                            const oe = rowIndex % 2 === 0 ? 'bg_tr_odd' : '';
                                            return (
                                            <tr key={rowIndex} className={oe}>
                                                {Object.keys(item).map((key) => (
                                                    <td key={key}>{item[key]}</td>
                                                ))}
                                            </tr>)
                                        })
                                    :
                                        <tr>
                                            <td colSpan={1000} className='empty_box'>
                                                <span className={`data_empty bg_tr_odd`} style={{ padding: '0.5rem' }}>
                                                    파일을 선택해주세요.
                                                </span>
                                            </td>
                                        </tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className='pr-1 overflow-scroll m-auto' style={{ minHeight: '10rem', maxHeight: '16rem', width: 'fit-content' }}>
                        <table>
                            <tbody>
                                {head[checked] ?
                                    <>
                                        {head[checked].map((row, Idx) => {
                                            const idx = String.fromCharCode(65 + Idx);
                                            return (
                                                <tr>
                                                    <td className='flex justify-center'>
                                                        <input type='text' className='rounded-none' value={row} readOnly={true} />
                                                        <select key={Idx} name={idx} className='rounded-none' value={changed[idx]} onChange={(e) => handelOptions(e)}>
                                                            {data.map((o) => {
                                                                return (<option key={o.COLUMN_NAME} value={o.COLUMN_NAME}>
                                                                    {o.COMMENTS}
                                                                </option>)
                                                            })}
                                                        </select>
                                                    </td>
                                                </tr>
                                            )
                                        })}
                                    </>
                                    :
                                    <></>}
                            </tbody>
                        </table>
                    </div>
                </div>}
            </div>
            <hr/>
            <div className='modal_btn_box'>
                <button className='modal_btn bg_tr_primary' onClick={save} >저장</button>
                <button className='modal_btn bg_co_black' onClick={exit} >닫기</button>
            </div>
        </div >
    );
};